import Container from './Container';

export default function Footer() {
  return (
    <Container>
      <div className="px-3 pt-5 pb-32 mt-16 flex justify-between text-white border-t border-white border-opacity-50">
        <div className="mb-2">
          <p className="text-sm font-bold leading-relaxed tracking-wider uppercase">Contact Us</p>
          <p className="text-sm leading-relaxed">support@api.bible</p>
        </div>
        <div className="mb-2">
          <p className="text-sm leading-relaxed"> ©2021 American Bible Society</p>
          <p className="text-sm leading-relaxed"> All rights reserved.</p>
        </div>
      </div>
    </Container>
  );
}
